<div class="container-gradient-info">
    <div class="container-graphs">
        <div class="container-volume">
            <div id="chartVolume"></div>
            <p class="text-chart-volume">Volumen</p>
        </div>
        <div class="container-trend-aux">
            <div id="chartTrend"></div>
            <p class="text-chart-trend">Buen momento para {{valueText.toLowerCase()}}</p>
        </div>
    </div>
    <p class="trend-text">Actualizado hace {{dateNow}}</p>
</div>
